var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.685 17.503c0-1.163 0-1.744-.144-2.218a3.33 3.33 0 0 0-2.222-2.222c-.473-.143-1.055-.143-2.218-.143H7.935c-1.163 0-1.745 0-2.218.143a3.33 3.33 0 0 0-2.222 2.222c-.144.474-.144 1.055-.144 2.218m10.417-11.25a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0"
  })));
};
export default SvgUser;